export default {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_NEWROUER: (state, newrouter) => {
    state.newrouter = newrouter
  },
  saveUserButtons(state, permissions) {
    state.permissions = permissions
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js